import React, {ReactElement, useState} from 'react'
import styled from 'styled-components'
import {IconType} from 'types'
import {getFontFamily, getFontSize, getThemeColor} from 'utils'
import {Icon, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'

interface ListExpandableProps {
  expanded: boolean
}

const StyledListItem = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  -webkit-tap-highlight-color: transparent;
  -webkit-tap-highlight-color: ${({theme}) =>
    getThemeColor(theme, 'white_1', 0)};
`
const StyledListItemTitle = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${convertUnit(4)};
`
const StyledListSubItem = styled.div<ListExpandableProps>`
  display: ${({expanded}) => (expanded ? 'visible' : 'none')};
  -webkit-tap-highlight-color: transparent;
  -webkit-tap-highlight-color: ${({theme}) =>
    getThemeColor(theme, 'white_1', 0)};
`
const StyledListText = styled(Paragraph)`
  font-size: ${getFontSize('l')};
  font-family: ${getFontFamily('medium')};
  padding: ${convertUnit(16)} 0;
`

interface LegalTutorialContentItemProps {
  text: string
  onClick(): void
  icon?: IconType
  expandable?: boolean
  subItem?: ReactElement
}

export default function LegalTutorialContentItem({
  text,
  onClick,
  icon,
  expandable = false,
  subItem,
}: LegalTutorialContentItemProps) {
  const [expand, setExpand] = useState(false)
  return (
    <>
      <StyledListItem
        className="pressable"
        onClick={() => (expandable ? setExpand((prev) => !prev) : onClick())}>
        <StyledListItemTitle>
          {icon && <Icon color="primary_5" type={icon} />}
          <StyledListText>{text}</StyledListText>
        </StyledListItemTitle>
        <Icon type={expand ? 'chevron-up' : 'chevron-right'} color="gray_3" />
      </StyledListItem>
      <StyledListSubItem expanded={expand} className="pressable">
        {subItem}
      </StyledListSubItem>
    </>
  )
}
